import MetaItem from './MetaItem'

export { MetaItem }
